import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { ClientConfirmationForm } from 'common/forms';
import { ClientConfirmationFormValues } from 'common/models/Forms';

import { QuestionTitle, PageControls } from '../../../../components';
import { selectProtocolCustomerConfirmation, setProtocolCustomerConfirmationValuesAction } from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function ProtocolCustomerConfirmationFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectProtocolCustomerConfirmation);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<ClientConfirmationFormValues>();

  function handleBackClick() {
    navigate(`/form/${id}/protocol/customer-statement`);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<ClientConfirmationFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: ClientConfirmationFormValues) {
    if (!isPrivileged) {
      dispatch(setProtocolCustomerConfirmationValuesAction(values));
    }

    navigate(`/form/${id}/protocol/consultant-confirmation`);
  }

  return (
    <>
      <QuestionTitle>{t('protocolFeature.customerConfirmation')}</QuestionTitle>
      <ClientConfirmationForm
        initialValues={initialValues || undefined}
        bindSubmit={bindSubmit}
        onSubmit={handleSubmit}
      />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
